module.exports = __webpack_public_path__ + "static/media/irAEs.c1d122aa.jpg";